interface LocalEmitterFunctionProps {
  eventName: string;
  data?: any;
}

const emitLocalEvent = (props: LocalEmitterFunctionProps) => {
  const { eventName, data } = props;

  let event;

  if (typeof MessageEvent === 'function') {
    event = new MessageEvent(eventName, { data });
  } else {
    event = document.createEvent('MessageEvent');
    event.initEvent?.(eventName, false, true);
  }

  document.dispatchEvent(event);
};

export default emitLocalEvent;
